module.exports = __webpack_public_path__ + "img/img (18).438179fe.jpg";